import { render, staticRenderFns } from "./DetailResearch.vue?vue&type=template&id=54422803&scoped=true"
import script from "./DetailResearch.vue?vue&type=script&lang=js"
export * from "./DetailResearch.vue?vue&type=script&lang=js"
import style0 from "./DetailResearch.vue?vue&type=style&index=0&id=54422803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54422803",
  null
  
)

export default component.exports